import React from 'react';
import { createPortal } from 'react-dom';
import Toast, { ToastMessage } from './Toast';
import './ToastContainer.scss';

interface ToastContainerProps {
  toasts: ToastMessage[];
  onDismiss: (id: string) => void;
}

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onDismiss }) => {
  const container = document.getElementById('modal-root') || document.body;

  return createPortal(
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onDismiss={onDismiss}
        />
      ))}
    </div>,
    container
  );
};

export default ToastContainer;